// extracted by mini-css-extract-plugin
export default {"main-menu":"MainMenu_main-menu__CPH1M"};